import axios from "axios";

const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;
export const API = `${BACKEND_URL}/api`;

export const http = axios.create({ baseURL: API, withCredentials: true });

export async function authMe() {
  const res = await fetch(`${API}/auth/me`, { credentials: "include" });
  if (!res.ok) throw new Error("unauth");
  return res.json();
}
export async function authSession(session_id) {
  const res = await fetch(`${API}/auth/session`, {
    method: "POST", credentials: "include",
    headers: { "Content-Type": "application/json" },
    body: JSON.stringify({ session_id }),
  });
  if (!res.ok) {
    if (res.status === 403) throw new Error("not-authorized");
    throw new Error("session exchange failed");
  }
  return res.json();
}
export async function authLogout() {
  await fetch(`${API}/auth/logout`, { method: "POST", credentials: "include" });
}

export async function loginEmail(email, password) {
  const { data } = await http.post("/auth/login", { email, password });
  return data;
}

export async function changePassword(current_password, new_password) {
  const { data } = await http.post("/auth/change-password", { current_password, new_password });
  return data;
}

export async function uploadFile(file, onProgress) {
  const form = new FormData();
  form.append("file", file);
  const { data } = await http.post("/files/upload", form, {
    headers: { "Content-Type": "multipart/form-data" },
    onUploadProgress: (e) => { if (onProgress && e.total) onProgress(Math.round((e.loaded / e.total) * 100)); },
  });
  return data;
}

export async function listFiles() {
  const { data } = await http.get("/files");
  return data;
}

export async function deleteFile(id) {
  const { data } = await http.delete(`/files/${id}`);
  return data;
}

export async function getBootstrap() {
  const { data } = await http.get("/bootstrap");
  return data;
}

export async function getConnectors() {
  const { data } = await http.get("/connectors");
  return data;
}

export async function getBriefing(kind, language = "en") {
  const { data } = await http.get(`/briefings/${kind}`, { params: { language } });
  return data;
}

export async function getJobs() {
  const { data } = await http.get("/jobs");
  return data;
}

export async function actOnDecision(id, action) {
  const { data } = await http.post(`/decisions/${id}/action`, { action });
  return data;
}

export async function getMemory() {
  const { data } = await http.get("/memory");
  return data;
}
export async function addMemory(m) {
  const { data } = await http.post("/memory", m);
  return data;
}
export async function deleteMemory(id) {
  const { data } = await http.delete(`/memory/${id}`);
  return data;
}

export async function getStyle() {
  const { data } = await http.get("/style");
  return data;
}
export async function createStyle(payload) {
  const { data } = await http.post("/style", payload);
  return data;
}
export async function toggleStyle(id) {
  const { data } = await http.post(`/style/${id}/toggle`);
  return data;
}
export async function deleteStyle(id) {
  const { data } = await http.delete(`/style/${id}`);
  return data;
}

export async function generateImage(prompt) {  const { data } = await http.post("/creative/image", { prompt });
  return data;
}
export async function getImages() {
  const { data } = await http.get("/creative/images");
  return data;
}

export async function transcribe(blob, language = "auto") {
  const form = new FormData();
  form.append("file", blob, "audio.webm");
  if (language) form.append("language", language);
  const { data } = await http.post("/voice/transcribe", form, {
    headers: { "Content-Type": "multipart/form-data" },
  });
  return data.text;
}

export async function speak(text, voice = "nova", speed = 1.0) {
  const { data } = await http.post("/voice/tts", { text: text.slice(0, 3500), voice, speed });
  return data.audio;
}

export async function updateProfile(payload) {
  const { data } = await http.put("/profile", payload);
  return data;
}
export async function getProfile() {
  const { data } = await http.get("/profile");
  return data;
}
export async function onboard(payload) {
  const { data } = await http.post("/onboard", payload);
  return data;
}
export async function getProactive() {
  const { data } = await http.get("/proactive");
  return data;
}

export async function addPerson(payload) {
  const { data } = await http.post("/people", payload);
  return data;
}
export async function updatePerson(id, payload) {
  const { data } = await http.put(`/people/${id}`, payload);
  return data;
}
export async function deletePerson(id) {
  const { data } = await http.delete(`/people/${id}`);
  return data;
}

// SSE streaming chat
export async function streamChat(payload, onEvent) {
  const res = await fetch(`${API}/chat`, {
    method: "POST",
    headers: { "Content-Type": "application/json" },
    body: JSON.stringify(payload),
  });
  const reader = res.body.getReader();
  const decoder = new TextDecoder();
  let buffer = "";
  while (true) {
    const { done, value } = await reader.read();
    if (done) break;
    buffer += decoder.decode(value, { stream: true });
    let idx;
    while ((idx = buffer.indexOf("\n\n")) >= 0) {
      const line = buffer.slice(0, idx);
      buffer = buffer.slice(idx + 2);
      if (line.startsWith("data: ")) {
        try {
          onEvent(JSON.parse(line.slice(6)));
        } catch (e) {
          /* ignore */
        }
      }
    }
  }
}
